var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16992 0.609375C12.1543 0.609375 15.4355 3.89062 15.4355 7.875C15.4355 11.8887 12.1543 15.1406 8.16992 15.1406C4.15625 15.1406 0.904297 11.8887 0.904297 7.875C0.904297 3.89062 4.15625 0.609375 8.16992 0.609375ZM10.5137 7.875C10.5137 6.58594 9.45898 5.53125 8.16992 5.53125C6.85156 5.53125 5.82617 6.58594 5.82617 7.875C5.82617 9.19336 6.85156 10.2188 8.16992 10.2188C9.45898 10.2188 10.5137 9.19336 10.5137 7.875Z",
    fill: "#3A6D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiIcon);
export default __webpack_public_path__ + "static/media/li-icon.747b8e9d3605b1460ddff28b608b237d.svg";
export { ForwardRef as ReactComponent };